/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material'

import { LegendItem } from '../Legend'
import { LegendRow } from '@app/components/Atoms/LegendRow'

interface LegendCategoricalProps {
  items: LegendItem[]
}

// Determines if two items ought to be separated
export const areSeparateItems = (item1: LegendItem, item2: LegendItem) => {
  const item1WithType = { type: 'fill', ...item1 }
  const item2WithType = { type: 'fill', ...item2 }

  return item1WithType.type !== item2WithType.type
}

export const LegendCategorical = ({ items }: LegendCategoricalProps) => {
  return (
    <Box>
      {items.map((item, itemIndex) => {
        return (
          <LegendRow
            key={item.label + itemIndex}
            label={item.label}
            swatch={item}
            logo={item.logo}
          />
        )
      })}
    </Box>
  )
}
